export default __webpack_public_path__ + "static/help_06_04-2-e6b89de094ba4bba6b589a1f4cfb9c09.png";